// Internet va navbat holati: "Internet bor", "Internetsiz · 3 kutmoqda", "2 ta yuborilmadi"
import { Icon } from '@onepos/ui';
import { useKassa } from './store';

export function SyncBadge({ onClick }: { onClick?: () => void }) {
  const { sync } = useKassa();
  const tone = sync.dead > 0 ? 'danger' : !sync.online ? 'warning' : sync.pending > 0 ? 'info' : 'ok';
  const text =
    sync.dead > 0
      ? `${sync.dead} ta yuborilmadi`
      : !sync.online
        ? sync.pending > 0
          ? `Internetsiz · ${sync.pending} kutmoqda`
          : 'Internetsiz'
        : sync.pending > 0
          ? `${sync.pending} yuborilmoqda`
          : 'Internet bor';
  const content = (
    <>
      <Icon name={sync.online ? 'wifi' : 'wifi-off'} />
      <span>{text}</span>
    </>
  );
  if (!onClick) {
    return (
      <span className={`ks-sync ks-sync--${tone}`} role="status">
        {content}
      </span>
    );
  }
  return (
    <button type="button" className={`ks-sync ks-sync--${tone}`} onClick={onClick} aria-label={`Internet va yuborish: ${text}`}>
      {content}
    </button>
  );
}
